<template>
  <div class="absolute top-0 left-0 right-0 p-4">
    <div class="container mx-auto max-w-screen-lg px-6">
      <div class="flex items-center text-white/90 text-sm space-x-2 overflow-x-auto whitespace-nowrap scrollbar-hide">
        <NuxtLink to="/events" class="hover:text-white flex-shrink-0">Events</NuxtLink>
        <Icon name="heroicons:chevron-right" class="w-4 h-4 opacity-50 flex-shrink-0" />

        <template v-if="category">
          <NuxtLink
            :to="`/events?category=${category.id}`"
            class="hover:text-white flex-shrink-0 max-w-[120px] sm:max-w-none truncate"
          >
            {{ category.title }}
          </NuxtLink>
          <Icon 
            name="heroicons:chevron-right" 
            class="w-4 h-4 opacity-50 flex-shrink-0" 
          />
        </template>

        <template v-if="tag">
          <NuxtLink
            :to="`/events?tags=${tag.id}&category=${category?.id}`"
            class="hover:text-white flex-shrink-0 max-w-[120px] sm:max-w-none truncate"
          >
            {{ tag.title }}
          </NuxtLink>
          <Icon
            name="heroicons:chevron-right"
            class="w-4 h-4 opacity-50 flex-shrink-0"
          />
        </template>

        <span class="truncate flex-shrink-0 max-w-[150px] sm:max-w-[200px] md:max-w-none">
          {{ title }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
.scrollbar-hide {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
</style>

  <script setup lang="ts">
  defineProps<{
    category?: {
      id: number;
      title: string;
    };
    tag?: {
      id: number;
      title: string;
    };
    title: string;
  }>();
  </script>